import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { I18nService } from 'src/app/services/i18n.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from 'src/app/services/user.service';
import { DialogContentLogin } from '../header-sticky/login-dialog/dialog-content-login';
import { pathRoutingEnum } from 'src/assets/constantEnum';

@Component({
    selector: 'app-verify-email',
    templateUrl: './verify-email.component.html',
    styleUrls: ['./verify-email.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VerifyEmailComponent implements OnInit {

  loading = true;
  success = false;
  error = '';


  private i18n = inject(I18nService);

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private dialog: MatDialog,
    private router: Router
  ) { }

  ngOnInit(): void {
    const token = this.route.snapshot.paramMap.get('token');
    if (!token) {
      this.loading = false;
      this.error = this.i18n.t('auth.verifyInvalidLink');
      return;
    }

    this.userService.verifyEmail(token).subscribe(() => {
      this.loading = false;
      this.success = true;
    }, (err) => {
      this.loading = false;
      this.error = err || this.i18n.t('auth.verifyExpiredLink');
    });
  }

  openLogin(): void {
    this.router.navigate([pathRoutingEnum.dashboard.valueOf()]);
    this.dialog.open(DialogContentLogin, { width: '550px' });

  }
}
